"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _PostEditor = _interopRequireDefault(require("./PostEditor.vue"));
var _ProfileEdit = _interopRequireDefault(require("./ProfileEdit.vue"));
var _Integrations = _interopRequireDefault(require("./Integrations.vue"));
var _Verification = _interopRequireDefault(require("./Verification.vue"));
var _Automation = _interopRequireDefault(require("./Automation.vue"));
var _MyChannels = _interopRequireDefault(require("./MyChannels.vue"));
const __default__ = {
  name: 'PrivateWall',
  components: {
    PostEditor: _PostEditor.default,
    ProfileEdit: _ProfileEdit.default,
    Integrations: _Integrations.default,
    Verification: _Verification.default,
    Automation: _Automation.default,
    MyChannels: _MyChannels.default
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    feed: {
      type: Array,
      required: true
    },
    isOwner: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showEditor: false,
      currentTab: 'posts'
    };
  },
  created() {
    // Al entrar, si detectamos éxito en auth, mostramos la pestaña de edición directamente
    const params = new URLSearchParams(window.location.hash.split('?')[1]);
    if (params.get('auth') === 'success') {
      this.currentTab = 'edit';
    }
  },
  computed: {
    filteredFeed() {
      return this.feed.filter(post => post.handle === this.user.handle);
    }
  },
  methods: {
    onPublish(newPost) {
      // Emitimos al padre (ImVerified) para que actualice el feed global
      this.$emit('publish', newPost);
      this.showEditor = false;
    }
  }
};
var _default = exports.default = /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    // Nota: Usamos props definidos arriba.

    return {
      __sfc: true,
      PostEditor: _PostEditor.default,
      ProfileEdit: _ProfileEdit.default,
      Integrations: _Integrations.default,
      Verification: _Verification.default,
      Automation: _Automation.default,
      MyChannels: _MyChannels.default
    };
  }
});